<div class="modal-body">
  <div id="modal-header-wrapper">
    <div id="title-wrapper">
      <a id="back-link" (click)="$event.preventDefault(); hideModal()" href="#" aria-label="Retour">
        <i i-bs name="arrow-left-short" width="30" height="30"></i>
      </a>
      <h2 id="title-text">{{ !!patientGroup ? 'Éditer un groupe' : 'Créer un nouveau groupe' }}</h2>
    </div>
    <p
      id="subtitle-text">{{ !!patientGroup ? 'Vous pouvez éditer le nom du groupe.' : 'Vous pourrez éditer et supprimer ensuite les groupes créés.' }}</p>
  </div>
  <div id="modal-content-wrapper">
    <form [formGroup]="form" name="edit-patient-group-form" (ngSubmit)="savePatientGroup()">
      <div id="name-form" class="form-field">
        <label>Nom du groupe</label>
        <input type="text" [class.is-invalid]="nameInvalid" class="form-control" id="name-input"
               placeholder="Nom du groupe" formControlName="name">
        <div class="invalid-feedback">
          Veuillez entrer un nom d'au moins 2 caractères.
        </div>
      </div>
      <div *ngIf="error" class="alert alert-danger" role="alert">
        {{ error }}
      </div>

      <accordion class="accordion">
        <accordion-group heading="Définir un profil de trackers pour ce groupe" [isOpen]="false" [panelClass]="'trackers-accordion'">
          <msd-tracker-manager #trackerManager
                               [dietitian]="currentDietitian"
                               [patientGroup]="patientGroup"
                               [maxTrackers]="maxTrackers"
                               [mode]="'PATIENT_GROUP'"
                               [liveSave]="false">
          </msd-tracker-manager>
        </accordion-group>
      </accordion>



      <div class="modal-footer">
        <button id="cancel-button" (click)="hideModal()" type="button"
                class="btn btn-outline-primary btn-outline text-only">
          Annuler
        </button>
        <button id="validate-button" [disabled]="!form.valid || isLoading" type="submit"
                class="btn btn-primary btn-gradient">
          <ng-container *ngIf="isLoading; else validateButton">
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            <span class="visually-hidden">Chargement...</span>
          </ng-container>
          <ng-template #validateButton>
            Valider
          </ng-template>
        </button>
      </div>

    </form>
  </div>
</div>
